import { supportConstants } from '../constants'


const initialState = {
    ticket: {
        list: [],
        error: null,
        loading: false,
        priority: {
            loading: false,
            error: null,
            list: []
        },
        type: {
            loading: false,
            list: []
        },
        accept: {
            loading: false,
            error: null,
            message: ""
        },
        addMessage: {
            loading: false,
            error: null,
            message: ""
        },
        details: {
            ticket: {},
            loading: false,
            hasError: null,
            shouldScroll: false,
        },
        close: {
            loading: false,
            error: null,
            message: ""
        },
    }
}

export function support(state = initialState, action) {
    switch (action.type) {
        case supportConstants.GET_TICKETS_LIST_REQUEST:
            return {
                ...state,
                ticket: {
                    ...state.ticket,
                    loading: true
                }
            }
        case supportConstants.GET_TICKETS_LIST_SUCCESS:
            return {
                ...state,
                ticket: {
                    ...state.ticket,
                    loading: false,
                    list: action.data
                }
            }
        case supportConstants.GET_TICKETS_LIST_FAILURE:
            return {
                ...state,
                ticket: {
                    ...state.ticket,
                    loading: false,
                    error: action.error
                }
            }
        case supportConstants.GET_TICKET_DETAILS_REQUEST:
            return {
                ...state,
                ticket: {
                    ...state.ticket,
                    details: {
                        ...state.ticket.details,
                        ticket: {},
                        loading: true,
                        hasError: null,
                        shouldScroll: false,
                    }
                },
            };
        case supportConstants.GET_TICKET_DETAILS_SUCCESS:
            let ticketDetails = action.data
            const matchTicketIndex = state.ticket.list.findIndex(element => element._id === ticketDetails._id)

            return {
                ...state,
                ticket: {
                    ...state.ticket,
                    details: {
                        ticket: {
                            ...state.ticket.list[matchTicketIndex],
                            message: ticketDetails.message,
                            hasCustomerSeen: ticketDetails.hasCustomerSeen,
                            hasEmployerSeen: ticketDetails.hasEmployerSeen,
                        },
                        loading: false,
                        hasError: null,
                        shouldScroll: true
                    }
                },
            };
        case supportConstants.GET_TICKET_DETAILS_FAILURE:
            return {
                ...state,
                ticket: {
                    ...state.ticket,
                    details: {
                        ...state.ticket.details,
                        ticket: {},
                        loading: false,
                        hasError: action.error,
                        shouldScroll: false,
                    }
                },
            };
        case supportConstants.ACCEPT_TICKET_REQUEST:
            return {
                ...state,
                ticket: {
                    ...state.ticket,
                    accept: {
                        ...state.ticket.accept,
                        loading: true,
                        error: null,
                    }
                },
            };
        case supportConstants.ACCEPT_TICKET_SUCCESS:
            return {
                ...state,
                ticket: {
                    ...state.ticket,
                    accept: {
                        ...state.ticket.accept,
                        loading: false,
                        message: action.data,
                        error: null,
                    }
                },
            };
        case supportConstants.ACCEPT_TICKET_FAILURE:
            return {
                ...state,
                ticket: {
                    ...state.ticket,
                    accept: {
                        ...state.ticket.accept,
                        loading: false,
                        error: action.error,
                    }
                },
            };
        case supportConstants.ADD_MESSAGE_TICKET_REQUEST:
            return {
                ...state,
                ticket: {
                    ...state.ticket,
                    addMessage: {
                        ...state.ticket.addMessage,
                        loading: true,
                        error: null,
                    }
                },
            };
        case supportConstants.ADD_MESSAGE_TICKET_SUCCESS:
            return {
                ...state,
                ticket: {
                    ...state.ticket,
                    addMessage: {
                        ...state.ticket.addMessage,
                        loading: false,
                        message: action.data,
                        error: null,
                    }
                },
            };
        case supportConstants.ADD_MESSAGE_TICKET_FAILURE:
            return {
                ...state,
                ticket: {
                    ...state.ticket,
                    addMessage: {
                        ...state.ticket.addMessage,
                        loading: false,
                        error: action.error,
                    }
                },
            };
        case supportConstants.CLOSE_TICKET_REQUEST:
            return {
                ...state,
                ticket: {
                    ...state.ticket,
                    close: {
                        ...state.ticket.close,
                        loading: true,
                        error: null,
                    }
                },
            };
        case supportConstants.CLOSE_TICKET_SUCCESS:
            return {
                ...state,
                ticket: {
                    ...state.ticket,
                    close: {
                        ...state.ticket.close,
                        loading: false,
                        message: action.data,
                        error: null,
                    }
                },
            };
        case supportConstants.CLOSE_TICKET_FAILURE:
            return {
                ...state,
                ticket: {
                    ...state.ticket,
                    close: {
                        ...state.ticket.close,
                        loading: false,
                        error: action.error,
                    }
                },
            };
        case supportConstants.UPDATE_TICKET_DETAILS_BY_ID:
            let ticket = action.data
            const ticketIndex = state.ticket.list.findIndex(element => element._id === ticket._id)
            state.ticket.list[ticketIndex] = {
                ...state.ticket.list[ticketIndex],
                ...ticket.message,
                hasCustomerSeen: ticket.hasCustomerSeen,
                hasEmployerSeen: ticket.hasEmployerSeen,
            }
            return state
        default:
            return state
    }
}
